// extracted by mini-css-extract-plugin
export default {"app":"Routes_app__l4M2P","appLogo":"Routes_appLogo__7nTGL","appLogoSpin":"Routes_appLogoSpin__22qWN","appHeader":"Routes_appHeader__fLmz4","appLink":"Routes_appLink__6V9rI"};